import React from "react";
import { Preview } from "@creatomate/preview";

import { Trans } from "app/utils";
import BurnSubtitleField from "./BurnSubtitleField";

interface BurnSubtitleOptionProps {
  activeLanguageCode?: string;
  preview: Preview;
}

const BurnSubtitleOption: React.FC<BurnSubtitleOptionProps> = ({
  activeLanguageCode, preview
}) => (
  <div className="Subtitles-Options">
    <span className="BurnText"><Trans>Burn Subtitles</Trans></span>
    <BurnSubtitleField
      activeLanguageCode={activeLanguageCode}
      preview={preview}
    />
  </div>
);

export default BurnSubtitleOption;
